<template>
  <div v-loading="loading">
    <!-- 财税 -->
    <div class="taxation_wrap" v-if="professional==2" :style="'height:'+(windowHeight-100)+'px'">
      <div class="taxation_main" v-if="isPrimary || isIntermediate">
        <primary v-if="isPrimary"></primary><!-- 初级 -->
        <intermediate v-if="isIntermediate"></intermediate><!-- 中级 -->
        <Senior v-if="isSenior"></Senior><!-- 高级 -->
        <intermediate-one v-if="istest"></intermediate-one><!-- 中级1.0 -->
      </div>
      <div class="no_app" v-else>
        <img src="../../../../static/images/kong.png" alt="加载失败"/>
        <p>暂无应用</p>
      </div>
    </div>
    <!-- 估值 -->
    <div class="assessment_wrap" v-if="professional==3" :style="'height:'+(windowHeight-100)+'px'">
      <valuation v-if="isAssessment"></valuation>
      <div class="no_app" v-else>
        <img src="../../../../static/images/kong.png" alt="加载失败"/>
        <p>暂无应用</p>
      </div>
    </div>
    <!-- 审计 -->
    <div class="audit_wrap" v-if="professional==1" :style="'height:'+(windowHeight-100)+'px'">
      <audit v-if="isAudit"></audit>
      <div class="no_app" v-else>
        <img src="../../../../static/images/kong.png" alt="加载失败"/>
        <p>暂无应用</p>
      </div>
    </div>
    <!-- 电商 -->
    <div class="socialmall_wrap" v-if="professional==8" :style="'height:'+(windowHeight-100)+'px'">
      <socialmall v-if="isDS"></socialmall>
      <div class="no_app" v-else>
        <img src="../../../../static/images/kong.png" alt="加载失败"/>
        <p>暂无应用</p>
      </div>
    </div>
    <!-- 三资 -->
    <div class="three_capital_wrap" v-if="professional==24" :style="'height:'+(windowHeight-100)+'px'">
      <Three-capital v-if="isSZ"></Three-capital>
      <div class="no_app" v-else>
        <img src="../../../../static/images/kong.png" alt="加载失败"/>
        <p>暂无应用</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '../../../api/userApi'
import primary from './components/primary'
import intermediate from './components/intermediate'
import Senior from "./components/senior.vue"
import valuation from './components/valuation'
import audit from './components/audit'
import socialmall from './components/socialmall'
import intermediateOne from './components/intermediateOne.vue'
import ThreeCapital from './components/threeCapital.vue'
export default {
  components: { primary, intermediate, Senior, valuation, audit, socialmall, intermediateOne, ThreeCapital },
  data() {
    return {
      loading: true,
      windowHeight: window.innerHeight,
      userType: sessionStorage.getItem('userType'), //用户身份
      professional: sessionStorage.getItem('professional'),//专业（2：智能财税,3：智能估值,1：智能审计,8：社交电商,24：农村三资）
      productFlag: sessionStorage.getItem('productFlag'),
      isIntermediate: false,
      isPrimary: false,
      isSenior: false,
      isAssessment: false,
      isAudit: false,
      isDS: false,
      isSZ: false,
      istest: false,
    };
  },
  created() {
    this.istest = (process.env.NODE_ENV=='development' || process.env.NODE_ENV=='uat') ? true : false
    this.getApp()
  },
  methods: {
    getApp(){//获取可用权限模块
      if(this.userType==2 || this.userType==3){
        this.isIntermediate = true
        this.isPrimary = true
        this.isSenior = true
        this.isSZ = true
      }else{
        if(this.productFlag==3){//综合实训
          let primaryArr = ['zledu.gxzx.zhsxappcs:ctx','zledu.gxzx.zhsxappcs:ptx','zledu.gxzx.zhsxappcs:jss','zledu.gxzx.zhsxappcs:zwfz']
          let intermediateArr = ['zledu.gxzx.zhsxappcsT:ctx','zledu.gxzx.zhsxappcsT:ptx','zledu.gxzx.zhsxappcsT:jss','zledu.gxzx.zhsxappcsT:zwfz','zledu.gxzx.zhsxappcs:gxl']
          let seniorArr = ['zledu.gxzx.zhsxappcsT:dsj']
          let mgyArr = ['zledu.gxzx.zhsxappgz:mgy']
          let auditArr = ['zledu.gxzx.zhsxappsj:sj']
          let dsArr = ['zledu.gxzx.zhsxappds:ds']
          let szArr = ['zledu.gxzx.zhsxappsz:kjhs','zledu.gxzx.zhsxappsz:bzzx','zledu.gxzx.zhsxappsz:zcgl','zledu.gxzx.zhsxappsz:zygl','zledu.gxzx.zhsxappsz:dzda','zledu.gxzx.zhsxappsz:jgcx']
          primaryArr.forEach(val=>{
            if(this.$_has(val)){
              this.isPrimary = true
              return
            }
          })
          intermediateArr.forEach(val=>{
            if(this.$_has(val)){
              this.isIntermediate = true
              return
            }
          })
          seniorArr.forEach(val=>{
            if(this.$_has(val)){
              this.isSenior = true
              return
            }
          })
          mgyArr.forEach(val=>{
            if(this.$_has(val)){
              this.isAssessment = true
              return
            }
          })
          auditArr.forEach(val=>{
            if(this.$_has(val)){
              this.isAudit = true
              return
            }
          })
          dsArr.forEach(val=>{
            if(this.$_has(val)){
              this.isDS = true
              return
            }
          })
          szArr.forEach(val=>{
            if(this.$_has(val)){
              this.isSZ = true
              return
            }
          })
        }else if(this.productFlag==4){//真实任务
          let primaryArr = ['zledu.gxzx.zsrwappcs:ctx','zledu.gxzx.zsrwappcs:ptx','zledu.gxzx.zsrwappcs:jss','zledu.gxzx.zsrwappcs:zwfz']
          let intermediateArr = ['zledu.gxzx.zsrwappcsT:ctx','zledu.gxzx.zsrwappcsT:ptx','zledu.gxzx.zsrwappcsT:jss','zledu.gxzx.zsrwappcsT:zwfz','zledu.gxzx.zsrwappcs:gxl']
          let mgyArr = ['zledu.gxzx.zsrwappgz:mgy']
          let auditArr = ['zledu.gxzx.zsrwappsj:sj']
          primaryArr.forEach(val=>{
            if(this.$_has(val)){
              this.isPrimary = true
              return
            }
          })
          intermediateArr.forEach(val=>{
            if(this.$_has(val)){
              this.isIntermediate = true
              return
            }
          })
          mgyArr.forEach(val=>{
            if(this.$_has(val)){
              this.isAssessment = true
              return
            }
          })
          auditArr.forEach(val=>{
            if(this.$_has(val)){
              this.isAudit = true
              return
            }
          })
        }else{
          this.isPrimary = false
          this.isIntermediate = false
          this.isSenior = false
          this.isAssessment = false
          this.isAudit = false
          this.isDS = false
          this.isSZ = false
        }
      }
      this.loading = false
    },
  }
}
</script>
<style lang="scss" scoped>
.taxation_wrap, .assessment_wrap, .audit_wrap, .socialmall_wrap, .three_capital_wrap {
  margin: 16px;
  padding: 0 16px;
  background: #fff;
  overflow-y: auto;
  .no_app{
    width: 280px;
    margin: 10% auto 0;
    text-align: center;
    img{
      width: 100%;
    }
    p{
      font-size:14px;
      font-weight:400;
      color:rgba(153,153,153,1);
      margin-top: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/appCenter.vue